// src/Pages/Landing/JoyrideEtelaSavoLanding.jsx
import React from "react";
import JoyrideMaakuntaLanding from "./JoyrideMaakuntaLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyrideEtelaSavoLanding() {
  return (
    <JoyrideMaakuntaLanding
      maakunta="Etelä-Savo"
      cities={[
        "Mikkeli",
        "Savonlinna",
        "Pieksämäki",
        "Juva",
        "Mäntyharju",
        "Puumala",
        "Kangasniemi"
      ]}
      regionText="Bilebändi Joyride tekee keikkoja myös Etelä-Savon alueelle tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Mikkelin, Savonlinnan ja Pieksämäen seutu sopivat hyvin esimerkiksi häihin, yritysjuhliin, kesäjuhliin ja pikkujouluihin, kun juhliin halutaan energinen livebändi."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}